<template>
    <div style="position: relative;">
      <canvas ref="progressChart"></canvas>
      <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); font-size: 24px;">
        {{ percentage }}%
      </div>
    </div>
  </template>
  
  <script>
  import Chart from 'chart.js';
  
  export default {
    props: {
      color:{
        type:String,
        default:'#10b981'
      },
      percentage: {
      }
    },
    mounted() {
      this.renderChart();
    },
    watch:{
        percentage :function(){
            this.renderChart();
        }
    },
    methods: {
      renderChart() {
        const ctx = this.$refs.progressChart.getContext('2d');
  
        const chart = new Chart(ctx, {
          type: 'doughnut',
          data: {
            datasets: [{
              data: [parseFloat(this.percentage), 100 - parseFloat(this.percentage)],
               backgroundColor: [this.color, '#f3f3f3']
            }]
          }, 
          options: {
            cutoutPercentage: 70,
            tooltips: {
              enabled: false
            },
            legend: {
              display: false
            }
          }
        });
  
        // Adjust canvas size
        const container = this.$refs.progressChart.parentElement;
        chart.canvas.width = container.clientWidth;
        chart.canvas.height = container.clientHeight;
      }
    }
  };
  </script>
  
  <style scoped>
  /* Add any additional styling here */
  </style>
  